import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { ScenarioNodeDto } from "../Types/types";
// import { ChildFormData } from "./types";

type ScenarioNodeDialogProps = {
  open: boolean;
  formData: ScenarioNodeDto;
  onChange: (e: any, field: string) => void;
  onClose: () => void;
  onSave: () => void;
};

const ScenarioNodeDialog: React.FC<ScenarioNodeDialogProps> = ({
  open,
  formData,
  onChange,
  onClose,
  onSave,
}) => {
  const handleChangeForm = (e: any, field: string) => {
    console.log(e);
    onChange(e.target.value, field);
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Scenario</DialogTitle>
      <DialogContent>
        <TextField
          label="Id"
          fullWidth
          margin="dense"
          value={formData.id}
          onChange={(e) => handleChangeForm(e, "id")}
        />
        <TextField
          label="question"
          fullWidth
          margin="dense"
          value={formData.question}
          onChange={(e) => handleChangeForm(e, "question")}
          // onChange={(e) => onChange(e.target.value)}
        />
        <TextField
          label="hint"
          fullWidth
          margin="dense"
          value={formData.hint}
          onChange={(e) => handleChangeForm(e, "hint")}
          // onChange={(e) => onChange(e.target.value)}
        />
        <TextField
          label="text"
          fullWidth
          margin="dense"
          value={formData.text}
          onChange={(e) => handleChangeForm(e, "text")}
          // onChange={(e) => onChange(e.target.value)}
        />
        <TextField
          label="parentId"
          fullWidth
          margin="dense"
          value={formData.parentId}
          onChange={(e) => handleChangeForm(e, "parentId")}
          // onChange={(e) => onChange(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScenarioNodeDialog;
